export default {
  chatContacts: [],
  chatContactInfos: null,
  selectedCustomerChats: {
    customerId: null,
    instanceId: null,
    chats: []
  },
  isSocketAlreadyListened: false,
  transferredChats: [],
  customersToRemoveIds: [],
  inboxMessagesStatus: 'seen',
  chatTab: 'my_chats',
  chatFilter: 'all',
  additionalChatFilter: 'search',
  chatContactDropdown: null,
  attendancePopupIsActive: false,
  chatPickingPopup: null,
  pickingPopupIsActive: false,
  chatFinalizePopup: null,
  finalizePopupIsActive: false,
  chatTransferPopup: null,
  transferPopupIsActive: false,
  groupsSelectedFilter: []
}
